import React from 'react';
import PropTypes from 'prop-types';
import './PhoneInventoryStats.css';

export const PhoneInventoryStats = ({ totalCount, assignedCount, unassignedCount, a2pCount }) => {
  const assignedPercentage = totalCount > 0 ? Math.round((assignedCount / totalCount) * 100) : 0;
  const unassignedPercentage = totalCount > 0 ? Math.round((unassignedCount / totalCount) * 100) : 0;
  const a2pPercentage = totalCount > 0 ? Math.round((a2pCount / totalCount) * 100) : 0;

  return (
    <div className="phone-inventory-stats">
      {/* Total Numbers */}
      <div className="stat-item" style={{minHeight:'114px'}}>
        <div className="stat-label" style={{textTransform:'none',fontSize:'14px'}}>Total Numbers</div>
          <div className="stat-label" style={{ marginTop: '-10px' }}></div>
        <div className="stat-value">{totalCount}</div>
      </div>

      {/* Assigned to Business Profile */}
      <div className="stat-item" style={{minHeight:'114px'}}>
        <div className="stat-label" style={{textTransform:'none',fontSize:'14px'}}>Business Profile</div>
        <div className="stat-label" style={{ marginTop: '-10px',textTransform:'none',fontSize:'14px' }}>Assigned Numbers</div>
        <div className="stat-value">{assignedCount}</div>
      </div>

      {/* Assigned to SMS Campaign */}
      <div className="stat-item" style={{minHeight:'114px'}}>
        <div className="stat-label" style={{textTransform:'none',fontSize:'14px'}}>SMS Campaign</div>
        <div className="stat-label" style={{ marginTop: '-10px',textTransform:'none',fontSize:'14px' }}>Assigned Numbers</div>
        <div className="stat-value">{a2pCount}</div>
      </div>

      {/* Not Assigned */}
      <div className="stat-item" style={{minHeight:'114px'}}>
        <div className="stat-label" style={{textTransform:'none',fontSize:'14px'}}>Not Assigned</div>
        <div className="stat-label" style={{ marginTop: '-10px',textTransform:'none',fontSize:'14px' }}></div>
        <div className="stat-value">{unassignedCount}</div>
      </div>
    </div>
  );
};

PhoneInventoryStats.propTypes = {
  totalCount: PropTypes.number.isRequired,
  assignedCount: PropTypes.number.isRequired,
  unassignedCount: PropTypes.number.isRequired,
  a2pCount: PropTypes.number,
};

PhoneInventoryStats.defaultProps = {
  a2pCount: 0,
};
